import {
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  ModalProps,
  Text,
} from '@chakra-ui/react';
import * as React from 'react';

import { Emoji } from '@/imports/ui/chakra/components/Emoji';

export const ExportInProgressModal: React.FC<
  Omit<ModalProps, 'children'> & { title: string }
> = ({ title, ...props }) => {
  return (
    <Modal {...props} isCentered size="xl">
      <ModalOverlay />

      <ModalContent>
        <ModalCloseButton />

        <ModalBody textAlign="center" pt="16" px="6">
          <Emoji
            label="pointing up"
            symbol="☝️"
            fontSize="4xl"
            lineHeight="normal"
          />

          <Heading as="h4" size="md" pt="2">
            {title}
          </Heading>
          <Text pt="2">
            Depending on the size of your export, it might take some time to
            process. We’ll send you an email with your export details once it’s
            complete!
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button onClick={props.onClose}>Got it!</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
